import React from 'react';
import './SkipNavButton.css';

function SkipNavButton() {
  return (
    <a href="#main-content" className="skip-nav-btn btn" tabIndex="1">
      Skip Navigation
    </a>
  );
}

export default SkipNavButton;
